import React from "react";
import { MailIcon, SettingsIcon } from "lucide-react";
import { Accordion } from "./Accordion";
import { OBJECTIONS } from "../lib/data";
export function Objections() {
  return <section className="px-4 pt-12 pb-4" data-id="element-125" data-mp="mjpivjzwn5su">
      <div className="mx-auto max-w-md" data-id="element-126" data-mp="miebla793fwz">
        <h2 className="text-center font-display text-xl font-extrabold text-slate-900" data-id="element-127" data-mp="hkuy4cidn763">
          Resolvemos tus dudas
        </h2>
        <div className="mt-5 space-y-3" data-id="element-128" data-mp="cm1ncruh5u9m">
          {OBJECTIONS.map(o => <Accordion key={o.q} title={o.q} data-id="element-129" data-mp="7vbciz3a4z7j">
              <p className="text-[13.5px] leading-relaxed text-slate-600" data-id="element-130" data-mp="7ti9dtrvkx4a">{o.a}</p>
            </Accordion>)}
        </div>

        <div className="mt-8 flex flex-col items-center text-center" data-id="element-131" data-mp="3r3rpczy03el">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-100" data-id="element-132" data-mp="3v1lwf2tt3ao4">
            <SettingsIcon className="h-6 w-6 text-slate-500" data-id="element-133" data-mp="3pzwjfhn0wmxe" />
          </div>
          <p className="mt-3 text-sm font-semibold text-slate-700" data-id="element-134" data-mp="3l2moxnks1l2p">Soporte</p>
          <a href="mailto:EbookDreamShop@gmail.com" className="mt-1 inline-flex items-center gap-1.5 text-sm font-bold text-teal-600" data-id="element-135" data-mp="gh2tl3xyyhw">
            <MailIcon className="h-4 w-4" data-id="element-136" data-mp="3mo8j3k63gtig" />
            EbookDreamShop@gmail.com
          </a>
        </div>
      </div>
    </section>;
}